<template>
  <div class="app-container">
    <!-- 工具栏 -->
    <div class="filter-container" style="padding-bottom:0">
      <el-button class="filter-item" size="small" type="primary" icon="el-icon-upload" @click="handleFile">导入Excel</el-button>
      <a target="_blank" :href="`${publicPath}dataTemplate.xlsx`" download="媒体数据导入模版.xlsx">
        <el-button class="filter-item" size="small" type="primary" icon="el-icon-download">下载Excel模板</el-button>
      </a>
    </div>

    <!-- 更新状态 -->
    <el-card class="box-card" shadow="never">
      <div slot="header" class="header-box">
        <div class="flex-box">
          <el-button class="filter-item" size="mini" type="danger" icon="el-icon-delete" @click="handleBatchSelete" v-if="multipleSelection.length > 0">批量删除</el-button>
          <span class="title">更新状态</span>
          <div class="filter-data">
            <div class="label filter-item">筛选：</div>
            <el-input size="mini" v-model="updatedSearch" placeholder="游戏、媒体、账号ID、用户账号" style="width:220px"></el-input>
          </div>
          <el-button class="filter-item" size="mini" type="primary" icon="el-icon-search" @click="handleFilter">查询</el-button>
        </div>

        <div class="filterTableHeader">
          <el-popover width="400" trigger="click">
            <el-button slot="reference" size="small" icon="el-icon-s-grid" style="font-size: 16px;padding:5px 10px;" title="筛选列"><i class="el-icon-caret-bottom"></i></el-button>
            <el-checkbox-group class="checkbox-table-headers" v-model="checkboxUpdatedOptions">
              <el-checkbox v-for="(item,index) in tableTheadUpdatedOptions" :key="index" :label="item">{{item[Object.keys(item)[0]]}}</el-checkbox>
            </el-checkbox-group>
          </el-popover>
        </div>
      </div>
      <!-- 表格 -->
      <el-table class="grayTableTile" size="mini" v-loading="updateListLoading" :data="updateList" border @sort-change="handleAgeSortChange" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="50" fixed></el-table-column>
        <!-- 排序sortable="custom" -->
        <el-table-column v-for="(item,index) in tableTheadsUpdated" :key="index" :fixed="index==0" :label="item[Object.keys(item)[0]]"
          :min-width="Object.keys(item)[0] == 'modifyTime' || Object.keys(item)[0] == 'modifyAccount' ? '140px' : Object.keys(item)[0] == 'campaignName' ? '180px' : '100px'"
          :sortable="(Object.keys(item)[0] == 'daytime' ||Object.keys(item)[0] == 'modifyTime' ||Object.keys(item)[0] == 'mediaName' ||Object.keys(item)[0] == 'cost')?'custom':false" :prop="Object.keys(item)[0]">
          <template slot-scope="scope">
            <span v-if="Object.keys(item)[0] == 'clientOs'"> {{scope.row.clientOs | clientType}} </span>
            <span v-else>{{scope.row[Object.keys(item)[0]]}}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" min-width="150px">
          <template slot-scope="scope">
            <el-button size="mini" style="padding: 4px 15px;" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" style="padding: 4px 15px;" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>

      </el-table>

      <!-- 分页 -->
      <pagination v-show="updatedTotal>0" :total="updatedTotal" :page.sync="listQueryUpdated.pageNo" :limit.sync="listQueryUpdated.pageSize" @pagination="getUpdateList" style="margin-top:0" />

    </el-card>

    <!-- 未更新状态 -->
    <el-card class="box-card" shadow="never" style="margin-top:20px" v-if="false">
      <div slot="header" class="header-box">
        <div class="flex-box">
          <span class="title">未更新</span>
          <div class="filter-data">
            <div class="label filter-item">筛选：</div>
            <el-input size="mini" v-model="updatedSearch_no" placeholder="游戏、媒体、账号ID、用户账号" style="width:220px"></el-input>
          </div>
          <el-button class="filter-item" size="mini" type="primary" icon="el-icon-search" @click="handleFilter_no">查询</el-button>
        </div>

        <div class="filterTableHeader">
          <el-popover width="400" trigger="click">
            <el-button slot="reference" size="small" icon="el-icon-s-grid" style="font-size: 16px;padding:5px 10px;" title="筛选列"><i class="el-icon-caret-bottom"></i></el-button>
            <el-checkbox-group class="checkbox-table-headers" v-model="checkboxUpdatedOptions_no">
              <el-checkbox v-for="(item,index) in tableTheadUpdatedOptions_no" :key="index" :label="item">{{item[Object.keys(item)[0]]}}</el-checkbox>
            </el-checkbox-group>
          </el-popover>
        </div>
      </div>

      <!-- 表格 -->
      <el-table class="grayTableTile" size="mini" v-loading="updateListLoading_no" :data="updateList_no" border @sort-change="handleAgeSortChange1">
        <!-- sortable="custom" -->
        <el-table-column v-for="(item,index) in tableTheadsUpdated_no" :key="index" :label="item[Object.keys(item)[0]]" :prop="Object.keys(item)[0]"
          :min-width="Object.keys(item)[0] == 'daytime' ? '100px' : Object.keys(item)[0] == 'modifyTime' || Object.keys(item)[0] == 'modifyAccount' ? '150px' : Object.keys(item)[0] == 'campaignName' ? '230px' : '130px'"
          :sortable="(Object.keys(item)[0] == 'daytime' ||Object.keys(item)[0] == 'modifyTime' ||Object.keys(item)[0] == 'mediaName' ||Object.keys(item)[0] == 'cost')?'custom':''"></el-table-column>

      </el-table>

      <!-- 分页 -->
      <pagination v-show="updatedTotal_no>0" :total="updatedTotal_no" :page.sync="listQueryUpdated_no.pageNo" :limit.sync="listQueryUpdated_no.pageSize" @pagination="getUpdateList_no" style="margin-top:0" />

    </el-card>

    <!-- 上传文件 -->
    <upload-excel ref="excel" @rebrushList="handleFilter"></upload-excel>

    <!-- 编辑消耗数据 -->
    <el-dialog class="dialog" title="编辑" v-if="dialogVisible" :visible.sync="dialogVisible" width="680px" top="5vh">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="日期：" prop="daytime">
          <el-date-picker size="small" v-model="ruleForm.daytime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" style="width:300px"></el-date-picker>
        </el-form-item>
        <el-form-item label="游戏：" prop="appkey">
          <el-select ref="gameSelect" size="small" v-model="ruleForm.appkey" placeholder="请选择活动区域" style="width:300px">
            <el-option v-for="item in gameOptions" :key="item.appkey" :label="item.name" :value="item.appkey"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="媒体：" prop="media">
          <el-cascader size="small" style="width:300px" v-model="ruleForm.media" :options="mediaOptions" :props="{ expandTrigger: 'hover' }"></el-cascader>
        </el-form-item>
        <el-form-item label="平台：" prop="clientOs">
          <el-select size="small" v-model="ruleForm.clientOs" placeholder="请选择活动区域" style="width:300px">
            <el-option v-for="item in clientOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="展示数：" prop="shows">
          <el-input class="numberInput" v-model="ruleForm.shows" type="number" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="点击数：" prop="click">
          <el-input class="numberInput" v-model="ruleForm.click" type="number" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="账面消耗：" prop="cost">
          <el-input class="numberInput" v-model="ruleForm.cost" type="number" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="实际消耗：" prop="costActual">
          <el-input class="numberInput" v-model="ruleForm.costActual" type="number" style="width:300px"></el-input>
        </el-form-item>
      </el-form>

      <div class="dialog-butn-box" style="margin: 20px 10px 10px">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" :loading="dialogLoading" @click="handleSave">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import UploadExcel from './components/uploadExcel'
import { find_uploadData, ajax_filterGame, find_CommonChannel, update_mateData, delete_mateData } from '@Sys~/api/sys'

import Store from '@Sys~/store'

// 更新状态所有表头
const defaultFormThead = [
  { daytime: '日期' },
  { modifyTime: '最后更新时间' },
  { campaignName: '游戏' },
  { mediaName: '媒体' },
  { clientOs: '平台' },
  { shows: '展示数' },
  { click: '点击数' },
  { cost: '账面消耗' },
  { costActual: '实际消耗' },
  { modifyAccountName: '更新账号' }
]
// 更新状态已选表头
const defaultChecked = [
  { daytime: '日期' },
  { modifyTime: '最后更新时间' },
  { campaignName: '游戏' },
  { mediaName: '媒体' },
  { clientOs: '平台' },
  { shows: '展示数' },
  { click: '点击数' },
  { cost: '账面消耗' },
  { costActual: '实际消耗' },
  { modifyAccountName: '更新账号' }
]

const name = Store.getters.currentRoute.name
export default {
  name:name,
  components: { Pagination, UploadExcel },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      // 更新状态
      updatedSearch: '', // 筛选
      updateListLoading: false, // 列表loading
      tableTheadUpdatedOptions: defaultFormThead, // 待选表头
      checkboxUpdatedOptions: defaultChecked, // 已选表头
      tableTheadsUpdated: defaultChecked, // 表格显示表头
      updateList: [], // 表格数据
      originalUpdateList: [], // 接口原数据
      updatedTotal: 0, // 总数
      listQueryUpdated: {
        pageNo: 1,
        pageSize: 10,
        orderColumn: "daytime",
        orderType: "desc",
      },

      multipleSelection: [], // 记录批量删除的数据

      // 编辑
      dialogVisible: false,
      ruleForm: {},
      rules: {
        appkey: [{ required: true, message: '请选择游戏', trigger: ['blur', 'change'] }],
        media: [{ required: true, message: '请选择媒体', trigger: ['blur', 'change'] }],
        clientOs: [{ required: true, message: '请选择平台', trigger: ['blur', 'change'] }],
        shows: [{ required: true, message: '请填写展示数', trigger: ['blur', 'change'] }],
        click: [{ required: true, message: '请填写点击数', trigger: ['blur', 'change'] }],
        cost: [{ required: true, message: '请填写账面消耗', trigger: ['blur', 'change'] }],
        costActual: [{ required: true, message: '请填写实际消耗', trigger: ['blur', 'change'] }],
      },
      gameOptions: [], // 游戏列表
      mediaOptions: [], // 媒体列表
      clientOptions: [{ value: 'android', label: 'Android' }, { value: 'ios', label: 'Ios' }], // 平台列表
      dialogLoading: false,

      // 未更新
      updatedSearch_no: '', // 筛选
      updateListLoading_no: false, // 列表loading
      tableTheadUpdatedOptions_no: defaultFormThead, // 待选表头
      checkboxUpdatedOptions_no: defaultChecked, // 已选表头
      tableTheadsUpdated_no: defaultChecked, // 表格显示表头
      updateList_no: [], // 表格数据
      originalUpdateList_no: [], // 接口原数据
      updatedTotal_no: 0, // 总数
      listQueryUpdated_no: {
        pageNo: 1,
        pageSize: 10,
        orderColumn: "daytime",
        orderType: "desc",
      },
    }
  },

  filters: {
    clientType(type) {
      const typeMap = {
        'android': 'Android',
        'ios': 'Ios'
      }
      return typeMap[type]
    }
  },

  watch: {
    // 筛选table header 更新状态
    checkboxUpdatedOptions(valArr) {
      this.tableTheadsUpdated = this.tableTheadUpdatedOptions.filter(i => JSON.stringify(valArr).indexOf(JSON.stringify(i)) > -1)
    },

    // 筛选table header 未更新状态
    checkboxUpdatedOptions_no(valArr) {
      this.tableTheadsUpdated_no = this.tableTheadUpdatedOptions_no.filter(i => JSON.stringify(valArr).indexOf(JSON.stringify(i)) > -1)
    }
  },

  created() {
    this.getUpdateList() // 获取更新状态数据

    // this.getUpdateList_no() // 获取未更新状态数据
  },

  methods: {
    // 获取更新状态数据
    getUpdateList() {
      this.updateListLoading = true
      const data = {
        pageNo: this.listQueryUpdated.pageNo,
        pageSize: this.listQueryUpdated.pageSize,
        queryParam: this.updatedSearch,
        orderColumn: this.listQueryUpdated.orderColumn,
        orderType: this.listQueryUpdated.orderType,
      }
      find_uploadData(data).then(response => {
        this.updateListLoading = false
        if (response.code == 1) {
          this.originalUpdateList = this.updateList = response.data.result
          this.updatedTotal = response.data.totalCount
        }
      })
    },

    // 查询
    handleFilter() {
      this.listQueryUpdated.pageNo = 1
      this.getUpdateList()
    },

    // 获取游戏列表
    getGameList() {
      ajax_filterGame().then(response => {
        if (response.code == 1) {
          this.gameOptions = response.data
        }
      })
    },

    // 获取公共渠道列表
    getCommonChannel() {
      find_CommonChannel().then(response => {
        if (response.code == 1) {
          this.mediaOptions = response.data
        }
      })
    },

    // 编辑
    handleEdit(row) {
      this.dialogVisible = true
      this.ruleForm = JSON.parse(JSON.stringify(row))
      this.$nextTick(() => {
        this.$refs['ruleForm'].clearValidate()
        this.getGameList()
        this.getCommonChannel()
      })
    },

    // 保存编辑
    handleSave() {
        var media = "";
        if (Array.isArray) {
            if(Array.isArray(this.ruleForm.media)) {
                media = this.ruleForm.media[this.ruleForm.media.length-1];
            }else{
                media = this.ruleForm.media;
            }
        }
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.dialogLoading = true
          const data = {
            id: this.ruleForm.id,
            daytime: this.ruleForm.daytime,
            appkey: this.ruleForm.appkey,
            campaignName: this.$refs['gameSelect'].$data.selectedLabel,
            media: media,
            clientOs: this.ruleForm.clientOs,
            shows: this.ruleForm.shows,
            click: this.ruleForm.click,
            cost: this.ruleForm.cost,
            costActual: this.ruleForm.costActual,
            modifyAccount: this.$store.getters.userId
          }
          update_mateData(data).then(response => {
            this.dialogLoading = false
            if (response.code == 1) {
              this.dialogVisible = false
              this.$message({
                type: 'success',
                message: '修改成功!'
              });
              this.getUpdateList()
            }
          })
        }
      })
    },

    // 删除
    handleDelete(row) {
      this.deleteData([row.id])
    },

    // 记录选中的数据
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // console.log(this.multipleSelection)
    },

    // 批量删除
    handleBatchSelete() {
      let ids = []
      this.multipleSelection.forEach(item => {
        ids.push(item.id)
      })
      this.deleteData(ids)
    },

    // 删除接口
    deleteData(ids) {
      this.$confirm('确认删除数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          ids: ids // 数组
        }
        delete_mateData(data).then(response => {
          if (response.code == 1) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.getUpdateList()
          }
        })
      }).catch(() => { });
    },

    // 导入
    handleFile() {
      this.$refs['excel'].init()
    },

    // 获取未更新状态数据
    getUpdateList_no() {
      this.updateListLoading_no = true
      const data = {
        pageNo: this.listQueryUpdated_no.pageNo,
        pageSize: this.listQueryUpdated_no.pageSize,
        queryParam: this.updatedSearch_no,
        orderColumn: this.listQueryUpdated_no.orderColumn,
        orderType: this.listQueryUpdated_no.orderType,
      }
      find_uploadData(data).then(response => {
        this.updateListLoading_no = false
        if (response.code == 1) {
          this.originalUpdateList_no = this.updateList_no = response.data.result
          this.updatedTotal_no = response.data.totalCount
        }
      })
    },

    // 查询
    handleFilter_no() {
      this.listQueryUpdated_no.pageNo = 1
      this.getUpdateList_no()
    },

    // 监听排序变化
    handleAgeSortChange(e) {
      console.log(e);
      if (e.order == "ascending") {
        this.listQueryUpdated.orderColumn = e.prop
        this.listQueryUpdated.orderType = "asc"
      } else if (e.order == "descending") {
        this.listQueryUpdated.orderColumn = e.prop
        this.listQueryUpdated.orderType = "desc"
      } else {
        this.listQueryUpdated.orderColumn = ""
        this.listQueryUpdated.orderType = ""
      }
      this.getUpdateList()
    },
    handleAgeSortChange1(e) {
      console.log(e);
      if (e.order == "ascending") {
        this.listQueryUpdated_no.orderColumn = e.prop
        this.listQueryUpdated_no.orderType = "asc"
      } else if (e.order == "descending") {
        this.listQueryUpdated_no.orderColumn = e.prop
        this.listQueryUpdated_no.orderType = "desc"
      } else {
        this.listQueryUpdated_no.orderColumn = ""
        this.listQueryUpdated_no.orderType = ""
      }
      this.getUpdateList_no()
    },


  }
}
</script>

<style lang="scss" scoped>
.box-card {
  background-color: #f1f1f1;
  ::v-deep .el-card__header {
    padding: 6px 20px !important;
  }
  ::v-deep .el-card__body {
    padding: 0;
  }
  .header-box,
  .flex-box,
  .filter-data {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
  }
  .header-box {
    .title {
      margin-right: 30px;
    }
    .filter-data {
      margin-right: 10px;
      .filter-item {
        width: 50px;
        margin-right: 5px;
        color: #808080;
      }
    }
  }
}
</style>

<style >
.numberInput input::-webkit-outer-spin-button,
.numberInput input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.numberInput input[type="number"] {
  -moz-appearance: textfield;
}
</style>